/**
 * 支付方式
 * @returns Array
 */
export default function() {
  return [
    {
      paymentMethod: 0,
      paymentMethodName: this.$t('confirmOrder.balance')
    },
    // {
    //   paymentMethod: 1,
    //   paymentMethodName: this.$t('confirmOrder.creditCard')
    // },
    {
      paymentMethod: 4,
      paymentMethodName: this.$t('confirmOrder.creditCard')
    },
    {
      paymentMethod: 9,
      paymentMethodName: this.$t('confirmOrder.creditCard')
    },
    {
      paymentMethod: 2,
      paymentMethodName: 'Paypal'
    },
    {
      paymentMethod: 3,
      paymentMethodName: 'Others'
    }
  ]
}
